import { Global } from '@emotion/react'
import LogRocket from 'logrocket'
import React, { useEffect } from 'react'

import { EuiProvider } from '@elastic/eui'

import useListenScreenSize from 'utils/useListenScreenSize'

import Routes from './Routes'

const AgenciesTheme = React.lazy(() => import('../whiteLabel/AgenciesTheme'))

const App: React.FC = () => {
  useListenScreenSize()

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      LogRocket.init('g51ouz/campaign-preview')
    }
  }, [])

  return (
    <EuiProvider colorMode='light'>
      <Global
        styles={{
          '*:focus:focus-visible': {
            outlineStyle: 'none'
          }
        }}
      />
      <React.Suspense fallback={<React.Fragment />}>
        <AgenciesTheme />
      </React.Suspense>

      <Routes />
    </EuiProvider>
  )
}

export default App
